import { CheckCircleOutlineTwoTone, ErrorOutline } from '@mui/icons-material';
import { Box, styled, Typography } from '@mui/material';

export const StyledStatusMessage = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const StyledTypography = styled(Typography)({
  fontSize: 12,
});

export const StyledIcon = styled(ErrorOutline)(({ theme }) => ({
  width: theme.spacing(2.5),
  height: theme.spacing(2.5),
}));

export const StyledErrorTypography = styled(StyledTypography)(({ theme }) => ({
  color: theme.palette.error.light,
}));

export const StyledErrorIcon = styled(StyledIcon)(({ theme }) => ({
  color: theme.palette.error.light,
}));

export const StyledPendingTypography = styled(StyledTypography)(
  ({ theme }) => ({
    color: theme.palette.warning.light,
  })
);

export const StyledPendingIcon = styled(StyledIcon)(({ theme }) => ({
  color: theme.palette.warning.light,
}));

export const StyledSuccessTypography = styled(StyledTypography)(
  ({ theme }) => ({
    color: theme.palette.success.light,
  })
);

export const StyledSuccessIcon = styled(CheckCircleOutlineTwoTone)(
  ({ theme }) => ({
    color: theme.palette.success.light,
  })
);
